/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var PageableCollection = require('psa-backbone/models/PageableCollection');

var PlaceholderView = require('common/views/PlaceholderView');

var GetOfficersByEntity = require('../../common/services/GetOfficersByEntity');

var DepEntityOfficersSectionView = require('../views/DepEntityOfficersSectionView');

module.exports = {
  channel: 'dp',

  event: 'build:officers-section-view',

  builder: function(entityId) {
    return new PlaceholderView({
      viewPromise: buildOfficersSectionView(entityId)
    });
  }
};

function buildOfficersSectionView(entityId) {
  var deferred = $.Deferred();
  GetOfficersByEntity(entityId)
    .done(function(officers) {
      var activeOfficers = _.filter(officers, function(fil) {
        return fil.status !== 'Inactive';
      });
      var inactiveOfficers = _.filter(officers, function(fil) {
        return fil.status === 'Inactive';
      });

      deferred.resolve(
        new DepEntityOfficersSectionView({
          collection: new PageableCollection(officers, { pageSize: 25 }),
          model: new Backbone.Model({
            activeOfficers: activeOfficers,
            inactiveOfficers: inactiveOfficers
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
